"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeployAadManifestArguments = exports.DeployAadManifestOptions = void 0;
exports.DeployAadManifestOptions = [
    {
        name: "entra-app-manifest-file",
        questionName: "manifest-file-path",
        type: "string",
        shortName: "a",
        description: "Specifies the Microsoft Entra app manifest file path, can be either absolute path or relative path to project root folder.",
        default: "./aad.manifest.json",
    },
    {
        name: "env",
        type: "string",
        description: "Specifies the environment name for the project.",
    },
];
exports.DeployAadManifestArguments = [];
//# sourceMappingURL=DeployAadManifestOptions.js.map